<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="../../assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
            <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">你没有访问权限!</h1>
            <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse">很抱歉你没有访问权限，请返回主页。</p>
            <div class="flex items-center">
                <a class="bg-primary text-white py-3 px-4 rounded" :href="homeUrl">返回主页</a>
                <span class="mx-3 text-xl">或</span>
                <a class="bg-warning text-white py-3 px-4 rounded cursor-pointer" @click="backToHome">退出登录</a>
            </div>
            
        </div>
    </div>
</template>

<script>
import config from '@/config/index'
import { clearToken } from '@/utils/tools'
export default {
    data() {
        return {
            homeUrl: config.shequUrl
        }
    },
    mounted() {
	    if (this.$store.state.eduRole == 'public') {
            if (this.$store.state.roles.length > 1) {
                this.$router.push({path: '/pages/permissionSelect'})
            }
        }
	},
    methods: {
        backToHome() {
            clearToken()
            this.$auth.logOut();
            this.$router.push('/pages/login');
        }
    }
}
</script>
